import React,{useState,useEffect,useRef} from 'react';
import ProfilePic from './ProfilePic';
import Axios from 'axios';
import LogoutButton from './LogoutButton';
import AlimModalSamll from './AlimModalSamll';
import ProfilePicToggle from './ProfilePicToggle';
import EditProfilePicContainer from './EditProfilePicContainer';
import LoaderCircle from './LoaderCircle';
import { alimSessionValid,alimUserRole } from '../../stores/sessionStore';

const UserProfileButton=()=>{
    const [isLoggedIn,setIsLoggedIn]=useState("loading");
    const [alimToken,setAlimToken]=useState("loading");
    const [userData,setUserData]=useState("loading");
    const [isProfilePicChange,setIsProfilePicChange]=useState(false);
    const [showProfileMenu,setShowProfileMenu]=useState(false);
    const [showSmallModal,setShowSmallModal]=useState(false);
    const [verifiedUserRole,setVerifiedUserRole]=useState(null);

    const menuRef=useRef();

    const navigateToLogin=()=>{
        const searchParams = new URLSearchParams(document.location.search);
        const sec=searchParams.get('sec');
        if(sec==="post-blog")
        {
            document.location.replace(`/login?after=${sec}`);
        }
        else
        {
            document.location.replace("/login");
        }
    }

    const doLogout=()=>{
        localStorage.removeItem("alim-login-token");
        localStorage.removeItem("alim-user-email");
        localStorage.removeItem("alim-user-data");
        localStorage.removeItem("alimProfilePic");
    }

    const initiateProfile=()=>{
        setAlimToken(localStorage.getItem('alim-login-token'));
        setUserData(JSON.parse(localStorage.getItem('alim-user-data')));
    }

    const checkUserRole=()=>{
        Axios.post(`${alimAPIBaseURI}rpc/get_user_role_by_email`, {},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            if(data.data==="blocked-user"||data.data==="temp-blocked-user")
            {
                doLogout();
                document.location.replace("/login");
            }
            setVerifiedUserRole(data.data);
            alimUserRole.set(data.data);
        })
    }

    const validateSession=()=>{
        const localAlimToken=localStorage.getItem('alim-login-token');
        Axios.post(`${alimAPIBaseURI}rpc/validate_jwt_session`, {},{headers: {"Content-Type": "application/json","Authorization":`bearer ${localAlimToken}`}}).then((data)=>{
            setAlimToken(localAlimToken);
            setIsLoggedIn("logged-in");
            const settingsbtn=document.getElementById('btgToggleGlobalSetting');
            if(settingsbtn!==null)
            {
                settingsbtn.classList.remove('md:flex')
            }
            checkUserRole();
            alimSessionValid.set(true);
        }).catch((error)=>{
            doLogout();
            navigateToLogin();
        })
    }

    useEffect(()=>{
        if(menuRef.current)
        {
            let menuHandler=(e)=>{
                if(!menuRef.current.contains(e.target))
                {
                    setShowProfileMenu(false);
                }
            };

            document.addEventListener("mousedown", menuHandler);

            return()=>{
                document.removeEventListener("mousedown", menuHandler);
            }
        }
    });

    useEffect(()=>{
        const profilePicHandler=()=>{
            setIsProfilePicChange(!isProfilePicChange);
            if(!isLoggedIn)
            {
                initiateProfile();
            }
            setShowSmallModal(false);
        }
        document.addEventListener("pro-pic",profilePicHandler);

        return()=>{
            document.removeEventListener("pro-pic", profilePicHandler);
        }
    });

    useEffect(()=>{
        if(alimToken!=="loading"&&userData!=="loading"&&alimToken!==null&&userData!==null)
        {
            validateSession();
        }

        if(alimToken===null&&userData===null)
        {
            setIsLoggedIn("logged-out");
        }
    },[alimToken,userData]);

    useEffect(()=>{},[isLoggedIn,verifiedUserRole])

    useEffect(()=>{
        const loginHandler=()=>{
            setAlimToken(localStorage.getItem('alim-login-token'));
            setUserData(JSON.parse(localStorage.getItem('alim-user-data')));
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{
        const universalEventHandler=()=>{
            setUserData(JSON.parse(localStorage.getItem('alim-user-data')));
        }
        document.addEventListener("alim-universal-event",universalEventHandler);

        return()=>{
            document.removeEventListener("alim-universal-event", universalEventHandler);
        }
    });

    useEffect(()=>{
        setAlimToken(localStorage.getItem('alim-login-token'));
        setUserData(JSON.parse(localStorage.getItem('alim-user-data')));
    },[]);

    if(isLoggedIn==="logged-in")
    {
        return(
            <div className='flex gap-1 items-center alim-text-color-style relative' ref={menuRef}>
                <div className='relative' onMouseEnter={()=>{setShowProfileMenu(true)}} onMouseLeave={()=>{setShowProfileMenu(false)}}>
                    <a href='/user' className='flex gap-1 items-center'>
                        <ProfilePic key={isProfilePicChange} webToken={alimToken} profileData={userData} profilePic={"load-profile"} customSize={"w-[40px] h-[40px]"} picChange={isProfilePicChange}/>
                        <span className='text-sm ml-1 truncate max-w-16 text-white'>{userData.first_name}</span>
                    </a>
                    <div className={`profile-pic-menu ${showProfileMenu?"open":"close"}`}>
                        <ProfilePic key={isProfilePicChange} webToken={alimToken} profileData={userData} profilePic={"load-profile"} customSize={"w-[100px] h-[100px]"} picChange={isProfilePicChange}/>
                        <div className='profile-submenu'>
                            <ProfilePicToggle modalFunc={setShowSmallModal} customPos={userData.user_role&&userData.user_role==="admin"?`top-[99px] -left-10`:`top-[81px] -left-10`}/>
                            <div className='relative overflow-hidden'>
                                <p className='pl-2.5 pt-2.5'>{userData.first_name} {userData.second_name}</p>
                                <p className='pl-2.5 mt-1 text-sm truncate w-[150px]' title={userData.user_email}>{userData.user_email}</p>
                                <a href='/user?sec=profile' className='bg-deep-red px-3 py-1 rounded-md ml-2.5 text-white text-xs mt-2.5 block w-fit'>
                                    Edit profile
                                </a>
                                {
                                    verifiedUserRole!==null&&verifiedUserRole==="admin"&&
                                    <a href='/admin-panel' className='bg-deep-red px-3 py-1 rounded-md ml-2.5 text-white text-xs mt-2.5 block w-fit'>
                                        Admin panel
                                    </a>
                                }
                                
                                <LogoutButton customStyles={"text-light-blue mt-2"}/>
                            </div>
                        </div>
                    </div>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-3 rotate-90 cursor-pointer text-white" onClick={()=>{setShowProfileMenu(!showProfileMenu)}}>
                    <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
                </svg>

                {showSmallModal&&<AlimModalSamll modalFunc={setShowSmallModal} customWidth={`w-[500px]`}>
                        <EditProfilePicContainer webToken={alimToken} userData={userData}/>
                    </AlimModalSamll>}
            </div>
        )
    }
    else if(isLoggedIn==="logged-out")
    {
        return(
            <a href="/login" className="flex text-white bg-deep-red px-2 lg:px-4 py-2 h-8 lg:h-fit text-xs lg:text-base red-button-hover-style items-center" title="Login to Alim.org"> 
                Login
            </a>
        );
    }
    else
    {
        return (
            <div className='flex justify-center items-center'>
                <LoaderCircle isAlwaysDarkMode={"1"}/>
            </div>
        );
        
    }
}

export default UserProfileButton;